var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00016 13.6666C10.6821 13.6666 13.6668 10.6818 13.6668 6.99992C13.6668 3.31802 10.6821 0.333252 7.00016 0.333252C3.31826 0.333252 0.333496 3.31802 0.333496 6.99992C0.333496 10.6818 3.31826 13.6666 7.00016 13.6666ZM10.0602 4.05322L5.66683 8.44656L3.94016 6.72656L3.00016 7.66656L5.66683 10.3332L11.0002 4.99989L10.0602 4.05322Z",
    fill: "#008862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckCircle);
export default __webpack_public_path__ + "static/media/green-check-circle.07fda89271cff608e0790b42c0175342.svg";
export { ForwardRef as ReactComponent };